export enum TrialNotificationKeys {
  available = 'HIDE_AVAILABLE_TRIAL_NOTIFICATION',
  pending = 'HIDE_PENDING_TRIAL_NOTIFICATION',
  endingSoon = 'HIDE_TRIAL_ENDING_SOON_NOTIFICATION',
  finished = 'HIDE_FINISHED_TRIAL_NOTIFICATION',
}
